import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../../../../translation/translation';
import StatusbarConstants from '../../../../../constants/statusbar_constants';

function AddPostcode({ onlyPostcodeMissing, status }) {
    const containerClassName = ['statusbar-mobile-current-status__postcode-cta'];

    if (onlyPostcodeMissing) {
        containerClassName.push('statusbar-mobile-current-status__postcode-cta--highlight-blue');
    } else if (status === StatusbarConstants.ALL_MISSING) {
        containerClassName.push('statusbar-mobile-current-status__postcode-cta--highlight-red');
    } else if (status === StatusbarConstants.DIMENSIONS_MISSING) {
        containerClassName.push('statusbar-mobile-current-status__postcode-cta--highlight-yellow');
    } else {
        containerClassName.push('statusbar-mobile-current-status__postcode-cta--highlight-blue');
    }

    return (
        <Translation
            translationKey="catalog-statusbar-mobile-enter-postcode-cta"
            className={containerClassName.join(' ')}
        />
    );
}

AddPostcode.propTypes = {
    onlyPostcodeMissing: PropTypes.bool,
    status: PropTypes.string,
};

AddPostcode.defaultProps = {
    onlyPostcodeMissing: false,
    status: '',
};

export { AddPostcode };
